import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";
import UserAuth from "./UserAuth";
import AdminAuth from "./AdminAuth";

export default function Auth() {
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [adminExists, setAdminExists] = useState(false);

  // Check if admin is configured in the database
  useEffect(() => {
    const adminRef = ref(db, "admin_settings/credentials/password");
    const unsubscribe = onValue(adminRef, (snapshot) => {
      setAdminExists(snapshot.exists());
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-[3rem] p-10 shadow-2xl border border-slate-100 dark:border-slate-800">
        {/* Toggle between User and Admin */}
        <div className="flex bg-slate-100 dark:bg-slate-800 p-2 rounded-2xl mb-8">
          <button
            onClick={() => setIsAdminMode(false)}
            className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${
              !isAdminMode
                ? "bg-white dark:bg-slate-700 shadow-sm text-indigo-600"
                : "text-slate-400"
            }`}
          >
            {" "}
            User Portal{" "}
          </button>
          <button
            onClick={() => setIsAdminMode(true)}
            className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${
              isAdminMode
                ? "bg-indigo-600 text-white shadow-lg"
                : "text-slate-400"
            }`}
          >
            {" "}
            Admin Portal{" "}
          </button>
        </div>

        {isAdminMode ? <AdminAuth adminExists={adminExists} /> : <UserAuth />}
      </div>
    </div>
  );
}
